import React, { useContext, useEffect, useRef, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import AppContext from "../context/AppContext";
import TimePickerField from "./TimePickerField";
import { deltaDates } from "../utils";
const FromToDateField = ({ params, onChange, minDate, maxDate, required, calendarPannels = 1, ...rest }) => {
   let fromField = params.from.field,
      toField = params.to.field,
      fromLabel = params.from.label,
      toLabel = params.to.label;
   const { registerPopupListener, popupCloseEvent } = useContext(AppContext);
   const [data, setData] = useState({ returnTrip: false });
   const refEl = useRef();
   const refFrom = useRef();
   const refTo = useRef();
   const [show, setShow] = useState(false);
   const valToDate = (d) => d.toDate().toISOString().split("T")[0];
   const onDateSelected = (d) => {
      let newData = null;
      if (d.length === 1) {
         newData = { ...data, [toField]: null, [fromField]: valToDate(d[0]) };
         setData((prev) => newData);
         refTo.current && refTo.current.focus();
         refEl.current.classList.add("show");
      } else {
         newData = { ...data, [toField]: valToDate(d[1]), returnTrip: true };
         setData((prev) => newData);
      }
      onDataChanged(newData);
   };

   const onTimeSelected = ({ name, value }) => {
      console.log({ name, value });
      setData((prev) => ({ ...prev, [name]: value }));
   };

   const clearPopups = () => {
      for (let d of document.querySelectorAll(".easyota-form-plugin .date-select")) {
         d.classList.remove("show");
      }
      setShow(false);
   };
   const handleOneway = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      let isReturn = !!data[fromField] && !!data[toField];
      let dataParams = { ...data, returnTrip: isReturn };
      setData((prev) => dataParams);
      onDataChanged(dataParams);
      clearPopups();
   };

   const handleShowHide = (ev) => {
      ev.stopPropagation();
      ev.preventDefault();
      if (ev.target.classList.contains("sd")) {
         // clearPopups();
      } else {
         popupCloseEvent();
         refEl.current.classList.add("show");
         setShow(true);
         refFrom.current && refFrom.current.focus();
      }
   };
   useEffect(() => {
      document.addEventListener("click", (ev) => {
         clearPopups();
      });
      registerPopupListener(() => {
         clearPopups();
      });
   }, [registerPopupListener]);

   const onDataChanged = (data) => {
      let isReturn = !!data[fromField] && !!data[toField];
      let dataParams = { ...data, returnTrip: isReturn };
      //Compute Delta
      if (isReturn) {
         let fromTime, toTime;
         if (params.from.withTime) {
            fromTime = data[params.from.withTime.field];
         }
         if (params.to.withTime) {
            toTime = data[params.to.withTime.field];
         }
         let delta = deltaDates(`${data[fromField]}T${fromTime || "00:00"}`, `${data[toField]}T${toTime || "00:00"}`);
         console.log("Delta: ", delta);
      }
      onChange && onChange(dataParams);
   };

   const PresentToolbar = () => {
      if (!data[fromField]) return <p>Select a {`${params.from.label}`} date</p>;
      if (!data[toField]) {
         return params.noOneway ? (
            <p>Select a {params.to.label} date</p>
         ) : (
            <>
               <p>Add {params.to.label} date or search one-way trips</p>
               <button type='button' onClick={handleOneway}>
                  One-way trip
               </button>
            </>
         );
      }

      return (
         <>
            <p>Confirm or change dates</p>
            <button type='button' onClick={handleOneway}>
               Confirm <b>{params.to.label}</b> date
            </button>
         </>
      );
   };
   let withTime = params.from.withTime || params.to.withTime;
   function dateValuePresent(d, t) {
      if (!d) return undefined;
      let dateStr = new Date(Date.parse(d)).toLocaleString("en-UK").split(",")[0];
      let res = t ? `${dateStr} ${t}` : dateStr;
      return res;
   }

   let calendarMinDate = data[toField] ? params.to.minDate || minDate : data[fromField] || params.to.minDate || minDate;
   let { anyTime, ...withTimeToRest } = params.to.withTime || {};
   return (
      <div className='date-from-to-wrap pos-relative' onClick={handleShowHide} style={{ flex: 2 }}>
         <div className='field pos-relative'>
            <label htmlFor={fromField} className='label from'>
               {fromLabel}
               <input
                  ref={refFrom}
                  onClick={handleShowHide}
                  required={required}
                  {...rest}
                  className='date'
                  type='text'
                  name={fromField}
                  id={fromField}
                  readOnly={show}
                  placeholder={params.from.placeholder || "Add date"}
                  defaultValue={dateValuePresent(data[fromField], data[`${fromField.split("_")[0]}_time`])}
               />
            </label>
            {data[fromField] && show && (
               <button
                  className='btn clear'
                  onClick={() => {
                     setData({ returnTrip: false });
                  }}
               >
                  <span>&#10009;</span>
               </button>
            )}
         </div>
         <div className='field pos-relative'>
            <label htmlFor={toField} className='label to'>
               {toLabel}
               <input
                  ref={refTo}
                  onClick={handleShowHide}
                  {...rest}
                  required={data.returnTrip}
                  className='date'
                  type='text'
                  name={toField}
                  id={toField}
                  placeholder={params.to.placeholder || "Add date"}
                  readOnly={show}
                  defaultValue={dateValuePresent(data[toField], data[`${toField.split("_")[0]}_time`])}
               />
            </label>
            {data[toField] && show && (
               <button
                  className='btn clear'
                  onClick={() => setData((prev) => ({ ...prev, [toField]: undefined, returnTrip: false }))}
               >
                  <span>&#10009;</span>
               </button>
            )}
         </div>
         <div ref={refEl} className='date-select'>
            <Calendar
               numberOfMonths={calendarPannels}
               disableMonthPicker
               disableYearPicker
               onChange={onDateSelected}
               minDate={calendarMinDate}
               maxDate={maxDate}
               showOtherDays={false}
               range={true}
               value={[data[fromField], data[toField]]}
            >
               <div className='toolbar-wrap'>
                  <div className='date-toolbar flex'>
                     <PresentToolbar />
                  </div>
               </div>
               {withTime && (
                  <div className='footer-wrap'>
                     {params.from.withTime && (
                        <div className='select-time from'>
                           <TimePickerField
                              {...params.from.withTime}
                              onChange={onTimeSelected}
                              required={data[fromField] || false}
                           />
                        </div>
                     )}
                     {params.to.withTime && (
                        <div className='select-time to'>
                           <TimePickerField
                              {...withTimeToRest}
                              onChange={onTimeSelected}
                              required={data[toField] || false}
                              maxTime={anyTime ? undefined : data[params.from.withTime.field]}
                           />
                        </div>
                     )}
                  </div>
               )}
            </Calendar>
         </div>
      </div>
   );
};

export default FromToDateField;
